module.exports = __webpack_public_path__ + "img/issue_coupon.8662f695.svg";